import { gql } from '@apollo/client';

export const VolunteerPublishedRosterFragments = gql`
  fragment VolunteerRosters on VOLUNTEER_PublishedRosteringType {
    publishedRosteringId
    dateRemoved
    sessionRosterings {
      session {
        name
        sessionId
      }
      startTime
      endTime
    }
    publishedRoster {
      activityDate
      name
      activity {
        activityId
      }
    }
  }
`;
